import { Injectable } from '@angular/core';
import { AlignComponent, IData, ISpacing } from '@app/feature/store-editor/components/layout/store-editor.interface';
import { APIResponse } from '@app/shared/services/core/ICore.interface';
import { environment } from '@env/environment';
import { CommonService as GCS } from '@app/shared/services/common/common.service';
import { LocalStorageService } from '@app/core/services/localStorage/local-storage.service';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { IUserLocalDetails } from '@app/core/services/localStorage/Ilocal-storage.interface';
import { Subject } from 'rxjs';
import { AppConstant } from '../../../shared/constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  user: IUserLocalDetails;
  constructor(
    private gcs: GCS,
    private ls: LocalStorageService,
    private lo: LoaderService,
    private http: HttpClient) {

    this.user = ls.getObject<IUserLocalDetails>(new IUserLocalDetails());
  }

  updateDesign: Subject<boolean> = new Subject<boolean>();

  listOfBorderStyle() {
    return ['dotted',
      'dashed',
      'solid',
      'double',
      'groove',
      'ridge',
      'inset',
      'outset'];
  }

  spacingExist(spacing: ISpacing) {
    if (spacing) {
      return true;
    } else {
      return 0;
    }
  }

  paddingString(spacing: ISpacing): string {
    if (!this.spacingExist(spacing)) {
      return '0';
    }
    return spacing.padding.top + 'px ' + spacing.padding.right + 'px ' + spacing.padding.bottom + 'px ' + spacing.padding.left + 'px';
  }

  borderString(spacing: ISpacing): string {
    if (!this.spacingExist(spacing)) {
      return '0';
    }
    return spacing.border.top + 'px ' + spacing.border.right + 'px ' + spacing.border.bottom + 'px ' + spacing.border.left + 'px';
  }

  marginString(spacing: ISpacing): string {
    if (!this.spacingExist(spacing)) {
      return '0';
    }
    return spacing.margin.top + 'px ' + spacing.margin.right + 'px ' + spacing.margin.bottom + 'px ' + spacing.margin.left + 'px';
  }

  setDefaultSetting(item: IData, align: AlignComponent = 'CENTER'): IData {
    if (!item.spacing) {
      item.spacing = {
        margin: { right: 0, left: 0, bottom: 0, top: 0 },
        border: { right: 0, left: 0, bottom: 0, top: 0 },
        padding: { right: 10, left: 10, bottom: 10, top: 10 }
      };
    }
    if (!item.textHtml) {
      item.textHtml = '';
    }
    if (!item.borderStyle) {
      item.borderStyle = {
        style: 'solid',
        color: '#000'
      };
    }
    if (!item.align) {
      item.align = align;
    }
    if (!item.fullWidth) {
      item.fullWidth = false;
    }
    if (!item.textColor) {
      item.textColor = '#000000';
    }    
    if (item.Heading != undefined) {
      //Overriding for slides only, as this is coming in the data thus assuming its being called from slide component
      item.spacing.padding = { right: 0, left: 0, bottom: 0, top: 0 };
      item.fullWidth = true;
    }
    if (!item.Heading && item.Heading != "") {
      item.Heading = "This is the heading of the Slider";
    }
    if (!item.SubHeading && item.SubHeading != "") {
      item.SubHeading = "Sub heading of the slider";
    }
    return item;
  }

  alignToFlex(align: AlignComponent): 'flex-end' | 'flex-start' | 'center' {
    switch (align) {
      case 'CENTER':
        return 'center';
      case 'LEFT':
        return 'flex-start';
      case 'RIGHT':
        return 'flex-end';
      default:
        return 'flex-start';
    }
  }

  uploadFileBlob(file: any): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        return this.uploadFile(file.name, reader.result.toString()).then(res => resolve(res));
      };
    });
  }

  uploadFile(FileName: string, fileBase64: string): Promise<string> {
    return new Promise((resolve, reject) => {
      this.lo.show();

      const base64Img = fileBase64.replace('data:image/png;base64,', '').replace('data:image/jpeg;base64,', '');
      this.gcs.uploadFile({
        ext: FileName.split('.').pop(),
        UserID: this.user.userId,
        File: base64Img
      }).subscribe((res: APIResponse<string>) => {
        this.lo.hide();
        if (res.StatusCode === 200) {
          resolve(res.Data.ResponseData);
        }
      });
    });
  }

  updateDesignOb() {
    return this.updateDesign.asObservable();
  }

  isItUpdated() {
    this.updateDesign.next(true);
  }

}
